import { CrossSellBanner, Layout, Button } from "@emanprague/ppaskit";
import type { ViewComponent } from "@frui.ts/views";
import { registerView, View } from "@frui.ts/views";
import { SapDashboardNotice } from "components/SapDashboardNotice";
import SupplyPointsList from "controls/supplyPointsList";
import { observer } from "mobx-react-lite";
import React from "react";
import OverviewViewModel from "viewModels/supplyPoints/overviewViewModel";

const overviewPageView: ViewComponent<OverviewViewModel> = observer(({ vm }) => {
  return (
    <>
      {vm.noticeText && <SapDashboardNotice text={vm.noticeText} onCancel={() => {}} translateFunc={vm.translateGeneral} />}
      <Layout fluid="xl" className="mt-3">
        <h1 className="sr-only">{vm.translate("title")}</h1>

        {vm.activeChild ? (
          <View vm={vm.activeChild} />
        ) : (
          <>
            <SupplyPointsList
              supplyPointsByType={vm.supplyPointsByType}
              localization={vm.localization}
              router={vm.router}
              onToggle={vm.updateHistoricalSupplyPoint}
            />
            {vm.showHistoricalSupplyPointButton && (
              <div className="d-flex justify-content-center">
                <Button variant="secondary" href={vm.router.getUrl("customerAccount", undefined, { manageHistorical: true })}>
                  {vm.translate("manage_historical_supply_points")}
                </Button>
              </div>
            )}
            {vm.crossSellBanner && (
              <CrossSellBanner
                title={vm.crossSellBanner.title}
                htmlContent1={vm.crossSellBanner.text1}
                htmlContent2={vm.crossSellBanner.text2}
                links={vm.crossSellBanner.links}
                topCenterMessage={vm.translateGeneral("cross_sell.top_center_message")}
                translateFunc={vm.translateGeneral}
              />
            )}
          </>
        )}
      </Layout>
    </>
  );
});

registerView(overviewPageView, OverviewViewModel);
